export default {"src":"/_next/static/media/KO.43d8a507.svg","height":18,"width":18};